import { RouterProvider } from 'react-router-dom';
import { App as AntApp } from 'antd';
import router from './router';
import AuthProvider from './features/auth/providers/AuthProvider';
import { Provider } from 'jotai';
import { store } from './store';

function App() {
  return (
    <Provider store={store}>
      <AntApp>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </AntApp>
    </Provider>
  );
}

export default App;
